import React from 'react';

const Alaska = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Alaska Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Nine-page form with checklist covering various property features must
          be provided before an offer.
        </li>
        <li>
          Disclosure Statement: Sellers must provide a Real Estate Transfer
          Disclosure Statement.
        </li>
        <li>
          Inspection Contingency: Commonly included due to extreme weather
          conditions.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Alaska-Real-Estate-Commission-Consumer-Pamphlet.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>
          – Per federal law, this document must be given to all buyers if the
          residence was constructed prior to 1978.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Alaska-Real-Estate-Property-Disclosure-Form-08-4229.pdf',
                '_blank'
              );
            }}
          >
            Property Disclosure Form{' '}
          </span>{' '}
          – Also known as Form 08-4229. The seller must provide this form prior
          to agreeing to an offer.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Alaska-Real-Estate-Commission-Consumer-Pamphlet.pdf',
                '_blank'
              );
            }}
          >
            Real Estate Commission Consumer Pamphlet{' '}
          </span>{' '}
          Real Estate Commission Consumer Pamphlet – Required if a real estate
          agent is working with one of the parties.
        </li>
      </ol>
    </div>
  );
};

export default Alaska;
